import React, { useReducer, useEffect } from "react";
import Reducer from "./reducer";
import { initialState } from "./initialState";
import Html from "./Html";
import Context from "./context";
import DisputesChat from "../chat";
import { fetchJobs } from "./service";

const AllDisputes = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        fetchJobs(dispatch); // Initial load
    }, []);

    return (
        <Context.Provider value={{state, dispatch}}>
            <Html/>
            <DisputesChat
                show={state.disputesChat?.is_show}
                dispute={state.disputesChat?.dispute}
                handleClose={() => dispatch({ type: 'SET_DISPUTESCHAT', disputesChat: {} })}
            />
        </Context.Provider>
    );
}

export default AllDisputes;